import { css, cx } from "@linaria/core"

import { getPrStatusClassName } from "@/components/GitHubIntegration/PrStatusStyles.tsx"
import { GithubFill, Icon12 } from "@/icons/Icons.ts"

import type { GitHubPrInfo } from "@/lib/client/generated/TypeDefinitions.ts"
import type { HTMLAttributes } from "react"

type GitHubPrBadgeProps = HTMLAttributes<HTMLDivElement> & {
  pr: GitHubPrInfo
}

export const GitHubPrBadge = ({ className, pr, ...props }: GitHubPrBadgeProps) => {
  return (
    <a href={pr.url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
      <span className={cx(styles.Badge, getPrStatusClassName(pr.state), className)} {...props}>
        <GithubFill className={Icon12} />
        {pr.state}
      </span>
    </a>
  )
}


const styles = {
  Badge: css`
    font-size: 9px;
    line-height: 14px;
    font-weight: 500;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    padding: 2px 6px;

    border-radius: var(--border-radius-8);
  `,
}